export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11414.b7cf8b72.jpg";